// Scrolling marquee: fills the band with enough copies of the messages and sets
// the loop distance and duration from the measured width, so the speed setting
// (pixels per second) holds at any screen size and message length.
if (!customElements.get('scrolling-marquee')) {
  class ScrollingMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-smq-track]');
      this.group = this.querySelector('[data-smq-group]');
      if (!this.track || !this.group) return;

      this.speed = parseFloat(this.dataset.speed) || 50;
      this.onResize = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.group);
      if (document.fonts) document.fonts.ready.then(this.onResize);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }

    update() {
      const groupWidth = this.group.getBoundingClientRect().width;
      if (!groupWidth) return;

      // One copy scrolls out while the rest fill the band, so the band needs
      // its own width plus one copy to never show a gap.
      const needed = Math.ceil(this.clientWidth / groupWidth) + 1;
      const groups = this.track.querySelectorAll('[data-smq-group]');
      for (let i = groups.length; i < needed; i++) {
        const copy = this.group.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.track.appendChild(copy);
      }
      for (let i = groups.length - 1; i >= Math.max(needed, 2); i--) groups[i].remove();

      const section = this.closest('.smq') || this;
      section.style.setProperty('--smq-distance', `${groupWidth}px`);
      section.style.setProperty('--smq-duration', `${(groupWidth / this.speed).toFixed(2)}s`);
    }
  }

  customElements.define('scrolling-marquee', ScrollingMarquee);
}
